import React from 'react'
import LinearProgress from '@mui/material/LinearProgress';
import Box from '@mui/material/Box';

export function SpacedDivider() {
  return (
    <Box sx={{ width: '100%', mb: 0.5, mt: 0.7 }}>
      <LinearProgress value={100}
        valueBuffer={100}
        variant='buffer' />
    </Box>
  )
}

export default SpacedDivider;
